const {substituteVars} = require('./other')
const URL = 'https://api.beatsaver.com/';
const FETCH_BY_HASH_URL = URL + '/maps/hash/${hash}';
const FETCH_BY_KEY_URL = URL + '/maps/id/${key}';

const jsonFetch = async url =>
  fetch(url)
    .then(response => {
      switch (response.status) {
        case 200:
          return response.json();
        case 404:
          throw '404 Not found';
        case 429:
          throw '429 Rate limit error'
        default:
          throw `${response.status} ${response.statusText}`
      }
    })

const byHash = async hash => jsonFetch(substituteVars(FETCH_BY_HASH_URL, {hash}))
const byKey = async key => jsonFetch(substituteVars(FETCH_BY_KEY_URL, {key}))

module.exports = {
  URL,
  FETCH_BY_HASH_URL,
  FETCH_BY_KEY_URL,
  byHash,
  byKey,
}